var _classCallCheck = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/inherits");

var Formatter = require('../../formatter');

var _require = require('./utils'),
    ReturningHelper = _require.ReturningHelper;

var Oracle_Formatter =
/*#__PURE__*/
function (_Formatter) {
  "use strict";

  _inherits(Oracle_Formatter, _Formatter);

  function Oracle_Formatter() {
    _classCallCheck(this, Oracle_Formatter);

    return _possibleConstructorReturn(this, _getPrototypeOf(Oracle_Formatter).apply(this, arguments));
  }

  _createClass(Oracle_Formatter, [{
    key: "alias",
    value: function alias(first, second) {
      return first + ' ' + second;
    }
  }, {
    key: "parameter",
    value: function parameter(value, notSetValue) {
      // Returning helper uses always ROWID as string
      if (value instanceof ReturningHelper && this.client.driver) {
        value = new this.client.driver.OutParam(this.client.driver.OCCISTRING);
      } else if (typeof value === 'boolean') {
        value = value ? 1 : 0;
      }

      return _get(_getPrototypeOf(Oracle_Formatter.prototype), "parameter", this).call(this, value, notSetValue);
    }
  }]);

  return Oracle_Formatter;
}(Formatter);

module.exports = Oracle_Formatter;